
















































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { AuthModule } from '@/store/Auth/AuthModule';
import { UsersModule } from '@/store/Settings/UsersModule';
import CreateUserRequest from '@/models/Settings/Users/CreateUserRequest';
import PageNames from '@/router/PageNames';
import Amount from '@/models/Shared/Amount';

@Component({ name: 'UserCreate' })
export default class extends SaascadaVueDialog {

    request: CreateUserRequest = new CreateUserRequest();
    approvalLimitAsNumber: number = 0;
    notificationLimitAsNumber: number = 0;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreateUserRequest();
        }
    }

    get currencySymbol() {
        return AuthModule.me.institution.defaultCurrency;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            const currency = AuthModule.me.institution.defaultCurrency;
            const paymentOrderApprovalLimitAmount = new Amount();
            paymentOrderApprovalLimitAmount.currency = currency;
            paymentOrderApprovalLimitAmount.amount = String(this.approvalLimitAsNumber);

            const paymentOrderApprovalNotificationLimitAmount = new Amount();
            paymentOrderApprovalNotificationLimitAmount.currency = currency;
            paymentOrderApprovalNotificationLimitAmount.amount = String(this.notificationLimitAsNumber);

            this.request.paymentOrderApprovalLimit = paymentOrderApprovalLimitAmount;
            this.request.paymentOrderApprovalNotificationLowerLimit = paymentOrderApprovalNotificationLimitAmount;

            await UsersModule.createUser(this.request);

            if (UsersModule.newUserId !== null) {
                this.$router.push({ name: PageNames.User, params: { id: UsersModule.newUserId } });
            }
        }
    }

}
